import { SHOWN_STIMULUS_TEXT } from '../../constants/eyetrackingConstants';
import type { ShownStimulus } from './pipedMedia';

export interface ShownImage {
  url: string;
  label: string;
}

const str = (v: unknown): string =>
  typeof v === 'string' || typeof v === 'number' ? String(v) : '';

/** The images a piped question showed, each with a short label (pair designs, product, shelf). */
export function shownImages(stimulus: ShownStimulus): ShownImage[] {
  const images: ShownImage[] = [];
  if (str(stimulus.left_url)) {
    images.push({
      url: str(stimulus.left_url),
      label: `${SHOWN_STIMULUS_TEXT.packA} · ${str(stimulus.left)}`,
    });
  }
  if (str(stimulus.right_url)) {
    images.push({
      url: str(stimulus.right_url),
      label: `${SHOWN_STIMULUS_TEXT.packB} · ${str(stimulus.right)}`,
    });
  }
  if (str(stimulus.image_url)) {
    images.push({ url: str(stimulus.image_url), label: str(stimulus.product_id) });
  }
  if (str(stimulus.shelf_image_url)) {
    images.push({
      url: str(stimulus.shelf_image_url),
      label: `${str(stimulus.shelf_id)} · ${SHOWN_STIMULUS_TEXT.chose} ${str(stimulus.chosen_product_id)}`,
    });
  }
  return images;
}
